import pluginFlagUtil from '@utils/pluginFlagUtil';
import dayjs from 'dayjs';
import { APP_INSTALL } from '../../const/localStorageKeys';
import { actions } from './reducer';
class Dispatch {
    constructor() {
        this.actions = actions;
    }
    set(flags) {
        return dispatch => {
            dispatch(actions.set(flags));
            if (!flags[APP_INSTALL]) {
                pluginFlagUtil.setFlag(APP_INSTALL, dayjs().toISOString());
            }
        };
    }
}
const FlagsDispatcher = new Dispatch();
export default FlagsDispatcher;
